import * as t from "io-ts";
import { ConsumerSignature } from "./ConsumerSignature";
import { Customer } from "./Customer";
import { Document } from "./Document";
import { InterestInCredit } from "./InterestInCredit";
import { JobInfo } from "./JobInfo";
import { MaxBudget } from "./MaxBudget";
import { PreferenceMap } from "./PreferenceMap";

export const EnquiryInfo = t.intersection([
  t.type({
    consumer: Customer,
    consumer_signature: ConsumerSignature,
  }),
  t.partial({
    quote: Document,
    job_info: JobInfo,
    interest_in_credit: InterestInCredit,
    budget: MaxBudget,
    consumer_preferences: PreferenceMap,
  }),
]);

export interface EnquiryInfo {
  consumer: Customer;
  consumer_signature: ConsumerSignature;
  quote?: Document;
  job_info?: JobInfo;
  interest_in_credit?: InterestInCredit;
  budget?: MaxBudget;
  consumer_preferences?: PreferenceMap;
}
